// extracted by mini-css-extract-plugin
export var cardImage = "gallery-module--cardImage--1c587";
export var container = "gallery-module--container--217de";
export var description = "gallery-module--description--b0554";
export var gallery = "gallery-module--gallery--a7e68";
export var galleryImage = "gallery-module--galleryImage--3b96c";
export var gatsbyImage = "gallery-module--gatsbyImage--2dc50";
export var pictureIndex = "gallery-module--pictureIndex--c123a";
export var visible = "gallery-module--visible--9c837";